import { createFileRoute } from '@tanstack/react-router';
import { pageHead } from '@/lib/routeHead';
import AdminAccountsPage from '@/pages/admin/AdminAccountsPage';

export const Route = createFileRoute("/_admin/admin/accounts")({
  head: () => pageHead('Accounts & Access | AKIVA Admin', 'Manage AKIVA Admin, Employee, Client, Partner and Member account access.', '/admin/accounts', true),
  component: AdminAccountsPage,
});